import React from 'react';
import { Modal, Form, Button, Spin, Icon, Row, Col, Input, Select } from 'antd';

import CatalogosRequest from '../../services/Catalogos'
import { openNotification } from '../../util/notificaciones';
import UsuarioNotificacionRequest from '../../services/UsuarioNotificaciones';
import BaseComponent from '../Common/BaseComponent';

const { Option } = Select;
const { confirm } = Modal;

class FormNotificaciones extends BaseComponent {
    state = {
        guardando: false,
        bloquearBotones: false,
        arrPlazas: [],
        arrTipoNotificacion: []
    }


    componentDidUpdate = (prevProps) => {
        let state = { ...this.state }

        if(this.props.modo === 'nuevo')
        {
            if(!state.arrPlazas.length)
            {
                CatalogosRequest.ListarPlazas()
                    .then(plazaResp => {
                    state.arrPlazas = plazaResp.data;

                    return CatalogosRequest.ListarTipoNotificaciones();
                })
                .then(tipoNotiresp => {
                    state.arrTipoNotificacion = tipoNotiresp.data;

                    state.cargando = false;
                    this.setState(state);
                })
                .catch(err => {
                    this.setState({ cargando: false });
                    openNotification(
                        "Ha ocurrido un error al listar las notificaciones.",
                        "Error al listar las notificaciones",
                        false
                    )
                });
            }
        }
        else
        {
            if ((this.props.usrNotificacion_selected !== prevProps.usrNotificacion_selected))
            {
                if(!state.arrPlazas.length)
                {
                    this.setState({ cargando: true }, () => {
                        CatalogosRequest.ListarPlazas()
                            .then(plazaResp => {
                                state.arrPlazas = plazaResp.data;

                                return CatalogosRequest.ListarTipoNotificaciones();
                            })
                            .then(tipoNotiresp => {
                                state.arrTipoNotificacion = tipoNotiresp.data;

                                state.cargando = false;
                                this.setState(state);
                            })
                            .catch(err => {
                                this.setState({ cargando: false })
                            })
                    });
                }
            }
        }
    }

    /**
     * Función que se cambia la plaza
     * @param: value. valor del id de la plaza
     * @return: nada.
     */
    onChangePlaza = (value) => {
        let state = { ...this.state }
        let drive_temp = (this.props.usuario_selected.rol === 4 || this.props.usuario_selected.rol === 5) ? null : []
        const { setFieldsValue } = this.props.form
        state.plazaSelected = null
        state.disableComboDrive = true;

       setFieldsValue({
            supervisores: [],
            drive: drive_temp
        })

        this.setState(state)
    }

    /**
        * Función que se manda a llamar cuando se cierra el modal.
    */
    handleCancel = () => {
        this.props.form.resetFields();
        this.props.esconderModal(false);

        this.setState({ bloquearBotones: false, plazaSelected: null, arrPlazas: [], arrTipoNotificacion: [] })
    }

    /**
     * Comportamiento al confirmar las notificaciones
     * @param: nada.
     * @return: nada.
     */
    showConfirm = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                confirm({
                    title: 'Confirmar',
                    content: <div><b>¿Está seguro de editar la notificación?</b> Se cambiará la información actual de la notificación.</div>,
                    okText: 'Aceptar',
                    cancelText: 'Cancelar',
                    okButtonProps: {
                        id: 'boton-aceptar-confirmacion-usuario-notificacion-form',
                    },
                    cancelButtonProps: {
                        id: 'boton-cancelar-confirmacion-usuario-notificacion-form',
                    },
                    onOk: () => {
                        this.setState({ cargando: true, bloquearBotones: true }, this.editarNotificacion())
                    },
                });
            }
        });
    }

     /**
     * Comportamiento al hacer clic en guardar la configuración de la notificación
     * @param: nada.
     * @return: nada.
     */
    editarNotificacion = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let state = { ...this.state }
                let objEnviar = {};
                objEnviar.plaza = [];
                let id_notificacion = null;

                if(this.props.usrNotificacion_selected !== undefined){
                    if (this.props.usrNotificacion_selected !== null) {
                        id_notificacion = this.props.usrNotificacion_selected.id;
                    }
                }
                
                objEnviar = {
                    nombre: values.nombre,
                    email: values.correo,
                    tipo_notificacion: values.tipo_notificacion,
                    plaza_id: values.plaza
                }

                this.setState({ cargando: true }, () => {
                    UsuarioNotificacionRequest.editarNotificacion(id_notificacion, objEnviar)
                        .then(resp => {
                            state.cargando = false;
                            state.bloquearBotones = false;
                            state.plazaSelected = null;
                            this.props.esconderModal(true);
                            this.props.form.resetFields();

                            openNotification(
                                resp?.data?.cuerpo,
                                resp?.data?.titulo,
                                true
                            )

                            this.setState(state);
                        })
                        .catch(err => {
                            this.setState({ cargando: false, bloquearBotones: false })
                            openNotification(
                                err?.response?.data?.cuerpo,
                                err?.response?.data?.titulo,
                                false
                            );
                        });
                });
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const usrNotificacion = this.props.usrNotificacion_selected;

        return(
            <div>
                <Modal
                    title= { this.props.modo === 'ver' ? 'Ver detalle notificación' : this.props.modo === 'editar' ? 'Editar notificación' : 'Nueva notificación'}
                    onCancel={this.handleCancel}
                    visible={this.props.visible}
                    onOk={this.showConfirm}
                    width={this.state.isPos ? "85%" : "70%"}
                    maskClosable={false}
                    centered={true}
                    footer={
                        [
                            <Button
                                id="boton-regresar-form-notificaciones"
                                className="btnCancelar"
                                key="back"
                                onClick={this.handleCancel}>
                                Regresar
                            </Button>,
                            <Button
                                className={this.props.modo === 'ver' ? 'display-none' : ''}
                                key="submit"
                                id="boton-guardar-usrNotificacion-form"
                                type="primary"
                                disabled={this.state.bloquearBotones}
                                onClick={this.showConfirm}
                            >
                                Guardar
                            </Button>
                        ]
                    }
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.guardando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}
                    >
                        <Form onSubmit={this.showConfirm}>
                            <Row gutter={12}>
                                <Col span={12}>
                                    <Form.Item
                                        label={ this.props.modo !== "ver" ? "Nombre" : <b>Nombre</b> }
                                        colon={(this.props.modo !== "ver" ? true : false)}
                                    >
                                        {   getFieldDecorator(
                                                'nombre', {
                                                    rules: [
                                                        { transform: value => { return value ? value.trim() : value }, type: "string" },
                                                        { required: this.props.modo !== "ver" ? true : false, message: 'Por favor, ingrese nombre.' },
                                                        { min: 2, message: "El nombre debe tener más de 2 caracteres." },
                                                        { max: 100, message: "Ha exedido el límite máximo de 100 caracteres." },
                                                        { whitespace: true, message: 'Por favor, ingrese nombre.' }
                                                    ],
                                                    initialValue: (
                                                        (this.props.usrNotificacion_selected !== undefined && this.props.usrNotificacion_selected !== null) ? this.props.usrNotificacion_selected.nombre : null
                                                    )
                                                }
                                            )
                                            (<Input
                                                style={{ width: "100%" }}
                                                id="input-nombre-form-usuario-notificacion"
                                                className={this.props.modo !== "ver" ? '' : 'disableInput'}
                                            />)
                                        }
                                    </Form.Item>
                                </Col>
                                 <Col span={12}>
                                    <Form.Item
                                        label={ this.props.modo !== "ver" ? "Correo" : <b>Correo</b> }
                                        colon={(this.props.modo !== "ver" ? true : false)}
                                    >
                                        {   getFieldDecorator(
                                                'correo', {
                                                    rules: [
                                                        { type:'email', message: 'El correo no es válido' },
                                                        { required: this.props.modo !== "ver" ? true : false, message: 'Por favor, ingrese el correo.' }
                                                    ],
                                                    initialValue: (
                                                        (this.props.usrNotificacion_selected !== undefined && this.props.usrNotificacion_selected !== null) ? this.props.usrNotificacion_selected.email : null
                                                    )
                                                }
                                            )
                                            (<Input
                                                style={{ width: "100%" }}
                                                id="input-correo-form-usuario-notificacion"
                                                className={this.props.modo !== "ver" ? '' : 'disableInput'}
                                            />)
                                        }
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={12}>
                                <Col span={12}>
                                    <Form.Item
                                        label={ this.props.modo !== "ver" ? "Tipo Notificación" : <b>Tipo Notificación</b> }
                                        colon={ this.props.modo === 'ver' ? false : true }
                                    >
                                        {
                                            getFieldDecorator(
                                                'tipo_notificacion', {
                                                    rules: [
                                                    {
                                                        required: this.props.modo === 'ver' ? false : true,
                                                        message: 'Por favor, seleccione una plaza.'
                                                    },
                                                    ],
                                                    initialValue: (
                                                        (this.props.usrNotificacion_selected !== undefined && this.props.usrNotificacion_selected !== null) ? this.props.usrNotificacion_selected.tipo_notificacion : null
                                                    )
                                                }
                                            )
                                            (
                                                <Select 
                                                    allowClear={this.props.modo !== "ver" ? true : false}
                                                    style={{ width: "100%" }}
                                                    notFoundContent='No hay opciones'
                                                    placeholder="Seleccionar..."
                                                    showSearch
                                                    showArrow={ this.props.modo === 'ver' ? false : true }
                                                    disabled={ this.props.modo === 'ver' ? true : false }
                                                    className={ this.props.modo === 'ver' ? 'disableInput' : '' }
                                                    id="select-plaza-form-usuario-notificacion"
                                                    defaultActiveFirstOption={false}
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                >
                                                    <Option value={null} disabled={true}>Seleccionar...</Option>
                                                    {
                                                        this.state.arrTipoNotificacion.length > 0 &&
                                                        this.state.arrTipoNotificacion.map(obj => {
                                                            return (
                                                                <Option
                                                                    key={obj.id}
                                                                    value={obj.id}>
                                                                    {obj.descripcion}
                                                                </Option>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                        <Form.Item
                                            label={ this.props.modo !== "ver" ? "Plaza" : <b>Plaza</b> }
                                            colon={ this.props.modo === 'ver' ? false : true }
                                        >
                                            {
                                                getFieldDecorator(
                                                    'plaza', {
                                                        rules: [
                                                        {
                                                            required: this.props.modo === 'ver' ? false : true,
                                                            message: 'Por favor, seleccione una plaza.'
                                                        },
                                                        ],
                                                        initialValue: (
                                                            ( usrNotificacion !== undefined && usrNotificacion !== null ) 
                                                            ? usrNotificacion.plaza.map(item => item.id) 
                                                            : []
                                                        )
                                                    }
                                                )
                                                (
                                                    <Select 
                                                        id="select-plaza-form-usuario-notificacion"
                                                        showSearch
                                                        style={{ width: "100%" }}
                                                        defaultActiveFirstOption={false}
                                                        notFoundContent='No hay opciones'
                                                        placeholder="Seleccionar..."
                                                        optionFilterProp="children"
                                                        allowClear
                                                        mode='multiple'
                                                        disabled={ this.props.modo === 'ver' ? true : false }
                                                        showArrow={ this.props.modo === 'ver' ? false : true }
                                                        className={ this.props.modo === 'ver' ? 'disableInput' : '' }
                                                    >
                                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                                        {
                                                            this.state.arrPlazas.length > 0 &&
                                                            this.state.arrPlazas.map(obj => {
                                                                return (
                                                                    <Option
                                                                        key={obj.id}
                                                                        value={obj.id}>
                                                                        {obj.nombre}
                                                                    </Option>
                                                                )
                                                            })
                                                        }
                                                    </Select>
                                                )
                                            }
                                        </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </Modal>
            </div>
        )
    }
}


export default Form.create()(FormNotificaciones);